import React from 'react';
import { Link, useHistory } from "react-router-dom";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import iconUserSettings from "assets/images/icons/project-icons/user-settings.svg";
import { ReactComponent as IconEmployees } from "assets/images/icons/project-icons/users-2.svg";
import { useEffect } from "react";


const Index = () => {
    const history = useHistory();

    useEffect(() => {
        history.push("/get-started/info/general");
    }, [history]);
    
    return ( 
        <div>

            <DynamicHeadTag headerText="Onboarding" />

            
            <div className="text-center max-w-sm mx-auto">
                <div className="font-medium text-lg">
                    Welcome to Earnipay &nbsp;👋
                </div>
                <div className="mt-2 text-fade-dark">
                    Complete your account setup to activate your account
                </div>
            </div>


            <div className="max-w-2xl mx-auto mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-6 place-items-center text-center">

                <Link to="/get-started/info/general" className="max-w-[300px] box py-10 group cursor-pointer">
                    <div className="w-16 h-16 rounded-full flex mx-auto bg-[#F1F6FE]">
                        <img src={iconUserSettings} alt="New Business" className="m-auto object-contain" />
                    </div>
                    <div className="mt-6">
                        <div className="font-medium text-lg">
                            Complete account setup
                        </div>
                        <div className="text-fade-dark mt-2">
                            Click the button to complete your account setup 
                        </div>
                        <div className="mt-3">
                            <button type="button" className="btn btn-ep-primary mt-8 mx-auto">
                                Activate your account
                            </button>
                        </div>
                    </div>
                </Link>

                <Link to="/people/employees/add" className="max-w-[300px] box py-10 group cursor-pointer">
                    <div className="w-16 h-16 rounded-full flex mx-auto bg-[#FF895A] bg-opacity-[.08]">
                        <IconEmployees className="m-auto svg-fill-orange" />
                    </div>
                    <div className="mt-6">
                        <div className="font-medium text-lg">
                            Add employee
                        </div>
                        <div className="text-fade-dark mt-2">
                            Click the button to create a new employee
                        </div>
                        <div className="mt-3">
                            <button type="button" className="btn btn-transparent-primary mt-8 mx-auto group-hover:bg-ep-primary group-hover:text-white">
                                Add employee
                            </button>
                        </div>
                    </div>
                </Link>

            </div>
            

        </div>
    )
}


export default Index;